import { useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { ListPage, EasyImg } from 'src/components'
import { $api } from 'src/plugins'
import 'enasops/styles/op/108/index.less'

const OP108 = () => {
  const [statistic, setStatistic] = useState({
    total: 0,
    enable: 0,
    disable: 0
  })
  useEffect(() => {
    $api['op108/getStatisticsData']().then(res => {
      res && setStatistic(res)
    })
  }, [])

  return (
    <div className='op108'>
      <div className='op108__statistic'>
        <EasyImg src={require('enasops/assets/op/108/user.png')} />
        <div className='item border-right'>
          <p>租户总数（个）</p>
          <p>{statistic.total}</p>
        </div>
        <div className='item border-right'>
          <p>启用租户数（个）</p>
          <p className='on'>{statistic.enable}</p>
        </div>
        <div className='item'>
          <p>禁用租总数（个）</p>
          <p className='off'>{statistic.disable}</p>
        </div>
      </div>
      <div className='op108__table'>
        <ListPage formCode='OP094' />
      </div>
    </div>
  )
}

export default observer(OP108)